import dayjs from 'dayjs';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useRouterFilters from 'hooks/useRouterFilters';

import { ENUMS, LOGS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const PickupRequestList = () => {
	const defaultSort = useMemo(() => [{ id: 'createdDate', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'otoOrderID',
				accessor: 'otoOrderID',
				filterType: FilterType.number,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'pickupId',
				accessor: 'pickupId',
				filterType: FilterType.string,
				showCopyButton: true
			},
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentId',
				filterType: FilterType.string,
				showCopyButton: true
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryCompany',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.DELIVERY_COMPANIES
			},
			{
				Header: 'message',
				accessor: 'message',
				filterType: FilterType.string
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			},
			{
				Header: 'logStatus',
				accessor: 'logStatus',
				filterType: FilterType.enum,
				enumName: ENUMS.SUCCESS_FAILURE,
				showOnMobile: true
			}
		],
		[]
	);

	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((c) => c.accessor === 'createdDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(4, 'day').startOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[]
	);

	const filtersFromRouter = useRouterFilters(columns);

	return (
		<div>
			<PageHeader
				title="pickupRequests"
				lordIcon="
				https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/reports-icon.json.gz"
			/>
			<DynamicList
				id={DYNAMICLISTS.PICKUP_REQUESTS}
				columns={columns}
				fetchUrl={LOGS.GET_PICKUP_REQUEST_LIST}
				defaultFilters={filtersFromRouter ?? defaultFilters}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.SUPPORT}
				exportName="pickupRequests"
			/>
		</div>
	);
};

export default PickupRequestList;
